import { Box } from 'bonfire-kindling';
import { ErrorMessage } from 'components';
import Recaptcha from 'react-google-recaptcha';

function RecaptchaField({ input, meta }) {
  return (
    <Box mt={4}>
      <Recaptcha
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        name={input.name}
        value={input.value}
        onChange={input.onChange}
      />
      {meta.submitError && !meta.dirtySinceLastSubmit && (
        <ErrorMessage message={meta.submitError} />
      )}
    </Box>
  );
}

export default RecaptchaField;
